import { Component, computed, effect, input, output, viewChild } from '@angular/core';

import {
  DateCellEditorValue,
  DatepickerDropdownComponent
} from '@shared/components/dropdown/template/datepicker-dropdown/datepicker-dropdown.component';
import {
  TimeCellEditorValue,
  TimeValue,
  TimepickerDropdownComponent
} from '@shared/components/dropdown/template/timepicker-dropdown/timepicker-dropdown.component';
import {
  WindowValues,
  processDatetimeValue,
  processTimeValue
} from '@shared/components/table/table-cell/utils';

export type DatetimeCellEditorValue =
  | Date
  | WindowValues<Date>
  | TimeValue
  | WindowValues<TimeValue>
  | undefined;
export type DatetimeCellEditorType = 'date' | 'datetime' | 'time';

@Component({
  selector: 'app-datetime-cell-editor',
  imports: [DatepickerDropdownComponent, TimepickerDropdownComponent],
  templateUrl: './datetime-cell-editor.component.html'
})
export class DatetimeCellEditorComponent {
  value = input.required<unknown>();
  disabled = input<boolean>(false);
  tableCellWidth = input<number>(0);
  range = input<boolean>(false);
  type = input<DatetimeCellEditorType>('datetime');

  valueChange = output<DatetimeCellEditorValue>();

  private inputElement = viewChild<
    DatepickerDropdownComponent | TimepickerDropdownComponent
  >('inputElement');

  constructor() {
    effect(() => {
      this.focus();
    });
  }

  protected focus(): void {
    const element = this.inputElement();
    if (element && 'focus' in element) {
      element.focus();
    }
  }

  protected processedValue = computed<DatetimeCellEditorValue>(() => {
    const type = this.type();
    const rawValue = this.value();

    if (type === 'time') {
      return processTimeValue(rawValue) as TimeCellEditorValue;
    } else {
      return processDatetimeValue(rawValue) as DateCellEditorValue;
    }
  });

  protected getDateTimeValue(): DateCellEditorValue {
    if (this.type() === 'time') return undefined;
    return this.processedValue() as DateCellEditorValue;
  }

  protected getTimeValue(): TimeCellEditorValue {
    if (this.type() !== 'time') return undefined;
    return this.processedValue() as TimeCellEditorValue;
  }

  protected onDateSelected($event: DateCellEditorValue) {
    this.valueChange.emit($event);
  }

  protected onTimeSelected($event: TimeCellEditorValue) {
    this.valueChange.emit($event);
  }
}
